import {DisclosurePageRef, EngagementId, TprmQuestionTemplateId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const disclosureSummary = typedQuery(
  ["tprm", "disclosureSummary", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.summary(engagementId);
  },
);

export const disclosurePageActivityStream = typedQuery(
  ["tprm", "disclosurePageActivityStream", param<EngagementId>("engagementId"), param<DisclosurePageRef>("page")],
  async (engagementId, page) => {
    return await api.tprm.disclosures.openPageActivityStream(engagementId, page);
  },
);

export const disclosureTailoring = typedQuery(
  ["tprm", "disclosureTailoring", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.getTailoring(engagementId);
  },
);

export const disclosureTailoringHistory = typedQuery(
  [
    "tprm",
    "disclosureTailoringHistory",
    param<EngagementId>("engagementId"),
    param<TprmQuestionTemplateId>("questionTemplateId"),
  ],
  async (engagementId, questionTemplateId) => {
    return await api.tprm.disclosures.getTailoringHistory(engagementId, questionTemplateId);
  },
);

export const disclosureDocuments = typedQuery(
  ["tprm", "disclosureDocuments", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.documents(engagementId);
  },
);
